import { render, staticRenderFns } from "./WizardViewPreparation.vue?vue&type=template&id=50a0ea38&"
import script from "./WizardViewPreparation.vue?vue&type=script&lang=js&"
export * from "./WizardViewPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports